import React from 'react';
import { useDispatch } from 'react-redux';

// library components
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useStaffingSelector } from 'redux/selectors/staffing/staffingSelectors';
import { openAddVolunteerRoleToProjectDialog } from 'redux/actions/staffingActions';
import AddVolunteerRoleToProjectForm from 'components/Forms/Staffing/AddVolunteerRoleToProjectForm';

const useStyles = makeStyles(theme => ({
  paperWidthSm: {
    maxWidth: 760,
  },
  contentRoot: {
    padding: theme.spacing(5),
  },
  dialogHeader: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogHeaderRoot: {
    padding: '24px 8px',
  },
  dialogHeaderTitle: {
    fontSize: 16,
    fontWeight: 500,
  },
  cancelButton: {
    position: 'absolute',
    right: theme.spacing(1),
  },
}));

const AddVolunteerRoleToProjectDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isOpenAddVolunteerRoleToProjectDialog, volunteerRoleToUpdateId } = useStaffingSelector();

  const closeDialog = () => {
    dispatch(openAddVolunteerRoleToProjectDialog(false));
  };

  return (
    <div>
      <Dialog
        open={isOpenAddVolunteerRoleToProjectDialog}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
        classes={{
          paperWidthSm: classes.paperWidthSm,
        }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          disableTypography
          className={classes.dialogHeader}
          classes={{ root: classes.dialogHeaderRoot }}
        >
          <Typography className={classes.dialogHeaderTitle}>
            {volunteerRoleToUpdateId ? 'Edit' : 'Add'} Volunteer Role
          </Typography>
          <IconButton className={classes.cancelButton} aria-label="close" onClick={closeDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className={classes.contentRoot}>
          <AddVolunteerRoleToProjectForm closeDialog={closeDialog} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddVolunteerRoleToProjectDialog;
